import { Button, Card } from '@/design-system';
import { useStartTour } from '@/features/tour';

import { accountCopy } from '../copy';

/**
 * De rondleiding nog eens: voor wie hem bij het eerste bezoek oversloeg, of een
 * collega op dezelfde plek wil meenemen. Opent het dashboard en begint bij stap 1.
 *
 * Er is geen kaart als er voor deze sessie geen rondleiding is: zonder omgeving,
 * of als een platformbeheerder meekijkt.
 */
export function TourCard() {
    const start = useStartTour();

    if (!start) {
        return null;
    }

    return (
        <Card padding="lg" as="section" aria-labelledby="tour-title">
            <h2
                id="tour-title"
                className="m-0 font-[family-name:var(--font-display)] text-[15px] leading-[1.3] font-semibold text-[var(--text-primary)]"
            >
                {accountCopy.tourTitle}
            </h2>
            <p className="m-0 mt-1 mb-3 text-[12px] leading-[1.45] text-[var(--text-tertiary-safe)]">
                {accountCopy.tourIntro}
            </p>
            <Button variant="outline" size="sm" onClick={start}>
                {accountCopy.tourRestart}
            </Button>
        </Card>
    );
}
